/*
 * pl-rankings — Selo Mais Vendido (Plenitude)
 * Desenha, lendo os JSONs que o snippet pl-rankings.liquid emite:
 *  1. selo "Nº 1 MAIS VENDIDO" acima do título da PDP (conquista mais forte:
 *     geral > macro > específica — o array já vem ordenado por força)
 *  2. nota ★ + nº de avaliações logo abaixo do título (clique rola pras reviews)
 *  3. régua de ícones da ficha (páginas/acabamento/versão/letra/editora)
 *  4. bloco "Ranking dos mais vendidos" com link pras páginas top-100/top-20
 *  5. mini-selo nos cards de coleção/busca/carrossel (nº1 por handle via
 *     shop metafield plenitude.selos; MutationObserver cobre grid com AJAX)
 * À prova de rebuild: arquivo nosso; âncoras no DOM do tema com null-check —
 * se a agência renomear uma classe, o módulo correspondente vira no-op.
 */
(function () {
  'use strict';

  function readJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (_) { return null; }
  }
  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // ---------- PDP ----------
  function pdp() {
    var data = readJson('pl-rankings-data');
    if (!data) return;
    var infos = document.querySelector('.main-product__infos');
    var titleWrap = infos && infos.querySelector('.main-product__title');
    if (!titleWrap) return;

    var posicoes = Array.isArray(data.rankings) ? data.rankings : [];
    var NIVEL_ORD = { geral: 0, macro: 1, especifica: 2 };

    // 1. selo estilo Amazon: MELHOR conquista no top 3 (menor posição; empate →
    // nível mais forte). Nº 1 dourado, nº 2 prata, nº 3 bronze.
    var top3 = posicoes.filter(function (p) { return p && p.posicao <= 3; })
      .sort(function (a, b) {
        var na = NIVEL_ORD[a.nivel] != null ? NIVEL_ORD[a.nivel] : 9;
        var nb = NIVEL_ORD[b.nivel] != null ? NIVEL_ORD[b.nivel] : 9;
        return a.posicao - b.posicao || na - nb;
      });
    var top = top3[0] || null;
    if (top) {
      var em = top.nivel === 'geral' ? 'em toda a loja' : 'em ' + top.categoria;
      var urlTop = top.nivel === 'geral' ? '/pages/mais-vendidos' : '/pages/mais-vendidos-' + top.slug;
      var MEDAL = "<svg viewBox='0 0 24 24'><circle cx='12' cy='8' r='6'/>" +
        "<path d='M15.477 12.89 17 22l-5-3-5 3 1.523-9.11'/></svg>";
      var podio = top.posicao === 1 ? '' : top.posicao === 2 ? ' pl-bs-p2' : ' pl-bs-p3';
      var badge = el('a', 'pl-bs',
        "<span class='pl-bs-chip" + podio + "'>" + MEDAL + 'Nº ' + top.posicao + ' Mais Vendido</span>' +
        "<span class='pl-bs-cat'>" + esc(em) + '</span>');
      badge.setAttribute('href', urlTop);
      titleWrap.parentNode.insertBefore(badge, titleWrap);
    }

    // 2. nota ★ no topo (fallback: badge do Judge.me já presente no DOM)
    var rating = parseFloat(data.rating);
    var reviews = parseInt(data.reviews, 10);
    if (!rating) {
      var jb = document.querySelector('.jdgm-prev-badge[data-average-rating]');
      if (jb) {
        rating = parseFloat(jb.getAttribute('data-average-rating'));
        reviews = parseInt(jb.getAttribute('data-number-of-reviews'), 10);
      }
    }
    var after = titleWrap; // insere na ordem: título → nota → régua
    if (rating && reviews > 0) {
      var full = Math.round(rating);
      var stars = '';
      for (var s = 1; s <= 5; s++) stars += s <= full ? '★' : '☆';
      var nota = el('div', 'pl-stars',
        "<span class='pl-s'>" + stars + "</span><span class='pl-n'>" +
        rating.toFixed(1).replace('.', ',') + '</span>' +
        "<a role='button'>(" + reviews + (reviews === 1 ? ' avaliação' : ' avaliações') + ')</a>');
      nota.querySelector('a').addEventListener('click', function (ev) {
        ev.preventDefault();
        var w = document.querySelector('.jdgm-rev-widg') ||
          document.querySelector('.jdgm-widget:not(.jdgm-preview-badge)');
        if (w) w.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      after.parentNode.insertBefore(nota, after.nextSibling);
      after = nota;
      // marca no <html> que a nossa linha existe — o CSS esconde o badge nativo do
      // Judge.me da seção (que renderiza DEPOIS deste script; JS não alcançaria)
      document.documentElement.setAttribute('data-pl-stars', '1');
    }

    // 3. preço: Pix protagonista (valor real à vista) + cartão embaixo + SKU
    // reposicionado pra baixo do título. A cara do valor (cor/fonte/tamanho) é
    // COPIADA do preço nativo do tema — mudou o tema, acompanha.
    // Lê o preço exibido pelo TEMA (nunca calcula preço de catálogo) e o desconto
    // pix do settings (mesma fonte do carrinho). Variante troca → re-render.
    function pdpPrice() {
      var pp = infos.querySelector('product-price.main-product__price') ||
        infos.querySelector('.main-product__price');
      var st = (window.Shopify && window.Shopify.theme && window.Shopify.theme.settings) || {};
      var pct = parseFloat(st.pix_discount);
      if (!pp || !st.enable_pix || !isFinite(pct) || pct <= 0) return;

      function parseBRL(s) {
        var m = String(s || '').match(/R\$\s*([\d.]+),(\d{2})/);
        return m ? parseFloat(m[1].replace(/\./g, '') + '.' + m[2]) : null;
      }
      function fmtBRL(v) {
        return 'R$ ' + v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?=,))/g, '.');
      }

      function render() {
        var cur = pp.querySelector('.product-price__current');
        if (!cur) return;
        var precoTxt = '';
        for (var i = 0; i < cur.childNodes.length; i++) {
          if (cur.childNodes[i].nodeType === 3) precoTxt += cur.childNodes[i].textContent;
        }
        // ⚠️ o preço "principal" do tema JÁ VEM com o desconto pix embutido
        // (incidente 06/07: aplicar % de novo mostrou preço 12% menor que o real).
        var pix = parseBRL(precoTxt);
        if (!pix) return;
        // preço real de cartão = soma das parcelas nativas; fallback: desfaz o % do pix
        var mParc = (((pp.querySelector('.info_installment') || {}).textContent || '')
          .replace(/\s+/g, ' ').match(/(\d+)x\s+de\s+R\$\s*([\d.,]+)/));
        var nParc = mParc ? parseInt(mParc[1], 10) : 0;
        var vParc = mParc ? parseBRL('R$ ' + mParc[2]) : null;
        var cartao = nParc && vParc ? Math.round(nParc * vParc * 100) / 100
          : Math.round((pix / (1 - pct / 100)) * 100) / 100;
        // fail-safe: pix tem que ser ≈ cartão×(1−pct%). Não fechou → deixa o nativo.
        var esperado = cartao * (1 - pct / 100);
        if (Math.abs(pix - esperado) > Math.max(0.03 * pix, 0.05)) return;

        var box = pp.querySelector('.pl-price');
        if (!box) {
          box = el('div', 'pl-price');
          var cont = pp.querySelector('.product-price__container') || pp;
          cont.appendChild(box);
        }
        var natBadgeTxt = ((pp.querySelector('.product-price__pix-discount-badge') || {}).textContent || '')
          .replace(/\s+/g, ' ').trim();
        box.innerHTML =
          "<div class='pl-pix-row'><span class='pl-pix-val'>" + esc(fmtBRL(pix)) + '</span>' +
          (natBadgeTxt ? "<span class='pl-pix-off'>" + esc(natBadgeTxt) + '</span>' : '') + '</div>' +
          "<div class='pl-pix-label'>no Pix (" + pct + '% de desconto à vista)</div>' +
          "<div class='pl-card'>ou <b>" + esc(fmtBRL(cartao)) + '</b>' +
          (mParc ? ' em até ' + nParc + 'x de ' + esc(fmtBRL(vParc)) + ' sem juros' : ' no cartão') + '</div>';

        // a cara do preço é a NATIVA do tema: copia cor/fonte/tamanho do original
        // (display:none não zera computed style)
        var natCs = getComputedStyle(cur);
        var pixVal = box.querySelector('.pl-pix-val');
        pixVal.style.color = natCs.color;
        pixVal.style.fontFamily = natCs.fontFamily;
        pixVal.style.fontSize = natCs.fontSize;
        pixVal.style.fontWeight = natCs.fontWeight;
        var natBadge = pp.querySelector('.product-price__pix-discount-badge');
        var offEl = box.querySelector('.pl-pix-off');
        if (natBadge && offEl) {
          var bCs = getComputedStyle(natBadge);
          // o badge nativo pode usar gradient (backgroundImage) com bg-color transparente
          var temCor = bCs.backgroundColor && bCs.backgroundColor !== 'rgba(0, 0, 0, 0)';
          var temImg = bCs.backgroundImage && bCs.backgroundImage !== 'none';
          if (temCor || temImg) {
            if (temCor) offEl.style.backgroundColor = bCs.backgroundColor;
            if (temImg) offEl.style.backgroundImage = bCs.backgroundImage;
            offEl.style.color = bCs.color;
          }
        }

        // SKU embaixo do nome do produto
        var sku = pp.querySelector('.product-price__sku');
        if (sku) {
          var skuTxt = sku.textContent.replace(/\s+/g, ' ').trim();
          var skuEl = infos.querySelector('.pl-sku');
          if (!skuEl) {
            skuEl = el('div', 'pl-sku');
            titleWrap.parentNode.insertBefore(skuEl, titleWrap.nextSibling);
          }
          skuEl.textContent = skuTxt;
        }
        document.documentElement.setAttribute('data-pl-price', '1');
      }
      render();
      var t = null;
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var alvo = muts[i].target;
          if (alvo.closest && alvo.closest('.pl-price')) return; // nossa própria escrita
        }
        clearTimeout(t);
        t = setTimeout(render, 150);
      }).observe(pp, { childList: true, subtree: true, characterData: true });
    }
    try { pdpPrice(); } catch (_) {}

    // 3c'. modal "Formas de pagamento": só ícones → linhas com as condições reais
    // (pix/parcelas das settings do tema; boleto do shop metafield plenitude.pagamentos;
    // linha só aparece se o método está em shop.enabled_payment_types)
    function pdpPagamentos() {
      var d = readJson('pl-pagamentos-data');
      var list = document.querySelector('.payment-methods__modal-content-list');
      if (!d || !list || list.querySelector('.pl-pay-row')) return;
      var metodos = (d.metodos || []).map(String);
      var icones = {};
      var svgs = list.querySelectorAll('svg');
      for (var i = 0; i < svgs.length; i++) {
        var lab = svgs[i].getAttribute('aria-label') ||
          (svgs[i].querySelector('title') || {}).textContent || '';
        if (lab) icones[lab.toLowerCase()] = svgs[i].cloneNode(true);
      }
      function ic(nome) {
        var s = icones[nome.toLowerCase()];
        return s ? s.outerHTML : '';
      }
      // barcode próprio: o svg de boleto do tema não tem aria-label (não coletável)
      var BARCODE = "<svg viewBox='0 0 24 24' fill='none' stroke='#0D1726' stroke-width='1.6'>" +
        "<path d='M3 6v12M6.5 6v12M9 6v8M12 6v12M15 6v9M17.5 6v12M21 6v12'/></svg>";
      var rows = '';
      if (d.enable_pix && d.pix > 0) {
        rows += "<div class='pl-pay-row'><span class='pl-pay-ic'>" + ic('Pix') + '</span>' +
          "<span class='pl-pay-t'>Pix</span>" +
          "<span class='pl-pay-d pl-pay-verde'>" + d.pix + '% de desconto à vista</span></div>';
      }
      if (d.boleto > 0) {
        rows += "<div class='pl-pay-row'><span class='pl-pay-ic'>" + (ic('Boleto') || BARCODE) + '</span>' +
          "<span class='pl-pay-t'>Boleto bancário</span>" +
          "<span class='pl-pay-d pl-pay-verde'>" + d.boleto + '% de desconto</span></div>';
      }
      if (d.parcelas > 0) {
        var CARTAO = "<svg viewBox='0 0 24 24' fill='none' stroke='#0D1726' stroke-width='1.6'>" +
          "<rect x='2' y='5' width='20' height='14' rx='2'/><path d='M2 10h20'/></svg>";
        rows += "<div class='pl-pay-row'><span class='pl-pay-ic'>" + CARTAO + '</span>' +
          "<span class='pl-pay-t'>Cartão de crédito</span>" +
          "<span class='pl-pay-d'>em até " + d.parcelas + 'x sem juros' +
          (d.parcela_min > 0 ? " <span class='pl-pay-min'>(parcela mín. R$ " + d.parcela_min + ')</span>' : '') +
          '</span></div>';
      }
      if (rows) list.innerHTML = rows;
    }
    try { pdpPagamentos(); } catch (_) {}

    // 3c. tag manual "Mais vendido" sai SEMPRE (decisão 06/07: quem sinaliza
    // best-seller agora é o ranking por dado fiscal, não a flag de cadastro)
    var tags = infos.querySelectorAll('.product-tag__text');
    for (var ti = 0; ti < tags.length; ti++) {
      if (tags[ti].textContent.replace(/\s+/g, ' ').trim().toLowerCase() === 'mais vendido') {
        var tag = tags[ti].closest('.product-tag');
        if (tag) tag.style.display = 'none';
      }
    }

    // 3d. alinhamento: no mobile o tema dá margin lateral (23px) aos blocos nativos
    // por classe própria — nossos elementos ficariam full-bleed ("cantos comidos").
    // Copia a margem computada do bloco do título; no desktop é 0 (no-op).
    function alinharMargens() {
      var cs = getComputedStyle(titleWrap);
      var els = infos.querySelectorAll('.pl-bs, .pl-sku, .pl-stars, .pl-rankblock');
      for (var mi = 0; mi < els.length; mi++) {
        els[mi].style.marginLeft = '';
        els[mi].style.marginRight = '';
      }
    }
    var rzT = null;
    window.addEventListener('resize', function () {
      clearTimeout(rzT);
      rzT = setTimeout(alinharMargens, 200);
    });

    // 4. bloco "Ranking dos mais vendidos" — logo abaixo do botão de compra.
    // Produto sem classificação não entra aqui (posicoes vazio → bloco nem existe).
    if (posicoes.length) {
      var lis = posicoes.map(function (p) {
        var url = p.nivel === 'geral' ? '/pages/mais-vendidos' : '/pages/mais-vendidos-' + p.slug;
        var em = p.nivel === 'geral' ? 'na loja inteira' : 'em ' + p.categoria;
        return '<li><b>Nº ' + p.posicao + '</b> ' + esc(em) +
          " &nbsp;·&nbsp; <a href='" + url + "'>ver ranking</a></li>";
      }).join('');
      var bloco = el('div', 'pl-rankblock',
        "<div class='pl-rb-title'>Ranking dos mais vendidos</div><ul>" + lis + '</ul>');
      var buy = infos.querySelector('.main-product__buying-options');
      if (buy) buy.parentNode.insertBefore(bloco, buy.nextSibling);
      else infos.appendChild(bloco);
    }
    alinharMargens(); // todos os elementos existem a partir daqui
  }

  // ---------- cards: limpa a tag manual em TODOS + mini-selo top-3 nos rankeados ----------
  function cards() {
    var selosRaw = readJson('pl-selos-data');
    var selos = {};
    (Array.isArray(selosRaw) ? selosRaw : []).forEach(function (s) { if (s && s.h) selos[s.h] = s; });

    function apply(root) {
      var list = (root || document).querySelectorAll('.product-card:not([data-pl-selo])');
      for (var i = 0; i < list.length; i++) {
        var card = list[i];
        card.setAttribute('data-pl-selo', '0');
        // tag manual "MAIS VENDIDO" sai de TODO card (decisão 06/07)
        var tags = card.querySelectorAll('.product-tag__text');
        for (var k = 0; k < tags.length; k++) {
          if (tags[k].textContent.replace(/\s+/g, ' ').trim().toLowerCase() === 'mais vendido') {
            var tg = tags[k].closest('.product-tag');
            if (tg) tg.style.display = 'none';
          }
        }
        var a = card.querySelector("a[href*='/products/']");
        if (!a) continue;
        var m = a.getAttribute('href').match(/\/products\/([a-z0-9-]+)/);
        var selo = m && selos[m[1]];
        if (!selo) continue;
        var host = card.querySelector('a.product-image') || a;
        host.classList.add('pl-card-host');
        var p = selo.p || 1;
        var txt = p === 1
          ? (selo.n === 'geral' ? 'Nº 1 na loja' : 'Nº 1 em ' + selo.t)
          : 'Nº ' + p + ' em ' + selo.t;
        var podio = p === 1 ? '' : p === 2 ? ' pl-mini-p2' : ' pl-mini-p3';
        var pill = el('span', 'pl-mini-bs' + podio, esc(txt));
        host.appendChild(pill);
        // senta ABAIXO da pilha de tags nativas (desconto + Lançamento) pra não colidir;
        // sem tags que desçam até a borda, fica no default do CSS (-12px, na borda da foto)
        var nativeTags = card.querySelectorAll('.product-tag');
        if (nativeTags.length) {
          var hostTop = host.getBoundingClientRect().top, maxB = -1e9;
          for (var ti = 0; ti < nativeTags.length; ti++) {
            var bb = nativeTags[ti].getBoundingClientRect().bottom - hostTop;
            if (bb > maxB) maxB = bb;
          }
          pill.style.top = Math.max(-12, Math.round(maxB) + 4) + 'px';
        }
        card.setAttribute('data-pl-selo', '1');
      }
    }
    apply(document);
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { apply(document); }, 300);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() { try { pdp(); } catch (_) {} try { cards(); } catch (_) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
